import { qualityApiClient } from '@/shared/api/core/axios-instance';

import type { DataZoneLowerCaseString, QualityLevel, SelectedSortByValue } from '@/entities/quality';

export type ColumnQualityApiResponse = {
  id: number;
  tableId: number;
  tableName: string;
  fqn: string;
  service: string;
  columnName: string;
  dataZone: DataZoneLowerCaseString;
  statDate: string;
  totalRows: number;
  goodRows: number;
  goodRatio: number;
  poorRows: number;
  poorRatio: number;
  unknownRows: number;
  unknownRatio: number;
  incrementalRows: number;
  qualityLevel: QualityLevel;
  collectedAt: string;
};

export type ColumnQualityApiParams = {
  dataZone?: string;
  service?: string;
  fromDate?: string;
  toDate?: string;
  tableId?: number;
  columnName?: string;
  qualityLevel?: string;
  sortBy: SelectedSortByValue;
  page: number;
  pageSize: number;
};

export type ColumnQualityApiResult = {
  success: boolean;
  data: ColumnQualityApiResponse[];
  meta: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
    fromDate?: string;
    toDate?: string;
  };
};

export const getColumnQualityData = async (params: ColumnQualityApiParams): Promise<ColumnQualityApiResult> => {
  const { data } = await qualityApiClient.get<ColumnQualityApiResult>('/stats/column-quality', { params });
  return data;
};
